// Module
var code = "<div class=row-fluid> <nlg-script-sql-query-report-list sql-base-url={{baseUrl}} domain=monitoring filter-service=filterService sql-filter-service-url={{filterServiceUrl}}> </nlg-script-sql-query-report-list> </div>";
// Exports
module.exports = code;